import Typography from '@mui/material/Typography';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import DraggableItem from '../Subcomponents/DraggableItem';
import CustomAccordion from '../../../components/Accordion/CustomAccordion';
import FunctionalityStageAccordion from './../Functionality/StageAccordionFunctionality';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const StageAccordion = ({
    stageIndex,
    stageProperties,
    expanded,
    setStageProperties,
    currentStage,
    setSelectedShape,
    selectedShape,
    setShowResources,
    setExpanded,
    updateForm,
}) => {
    const { t, onDragEnd, handleDeleteShape, procesName } = FunctionalityStageAccordion({
        stageProperties,
        setStageProperties,
        currentStage,
    });
    // Function to handle the change of the expanded panel
    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };
    return (
        <CustomAccordion
            title={`panel${stageIndex}`}
            header={
                <Typography className='subtitle-layer'>
                    {stageIndex === 1 ? t('front_card') : t('back_card')}
                </Typography>
            }
            onClick={() => handleChange(`panel${stageIndex}`)}
            currentKey={`panel${stageIndex}`}
            activeKey={expanded}
            onSelect={(key) => setExpanded(key)}
        >
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId={`droppable-${stageIndex}`}>
                    {(provided, snapshot) => (
                        <div className='layer-list' ref={provided.innerRef} {...provided.droppableProps}>
                            {stageProperties[stageIndex].combinedObject
                                .slice()
                                .reverse()
                                .map((item, index) => (
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided, snapshot) => (
                                            <DraggableItem
                                                item={item}
                                                index={index}
                                                selectedShape={selectedShape}
                                                setSelectedShape={setSelectedShape}
                                                setShowResources={setShowResources}
                                                updateForm={updateForm}
                                                provided={provided}
                                                snapshot={snapshot}
                                                handleDeleteShape={handleDeleteShape}
                                                procesName={procesName}
                                                t={t}
                                            />
                                        )}
                                    </Draggable>
                                ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </CustomAccordion>
    );
};

export default StageAccordion;
